import React      from "react";
import List       from "../components/list";
import ListItem   from "../components/list-item";
import ServiceTag    from "../components/servise-tag";
import Spinner    from "../components/spinner";
import View       from "./view";
import messages   from "../../../messages";
import config     from "../../../config";

export default class TagsView extends View {
    static get title () {
        return "выберите группу";
    }

    static get titleShort() {
        return "группы услуг";
    }

    static get defaultProps() {
        return Object.assign({}, super.defaultProps, {
            doctor: null,
        });
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            clinic: React.PropTypes.number.isRequired,
            doctor: React.PropTypes.string,
        });
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor (props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null,
            visibleItems: null,
            term: "",
        });
        this._isMounted = false;
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            item: null,
        });
        const clinic = this.props.clinic;

        const url = `${config.dataUrl}api.php?function=tags`  +
            `&clinic=${clinic}`;

        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status === true) {
                    const sorted = responseJson.tags.sort(
                        (a,b) => {
                            return Number(a.order) - Number(b.order) > 0 ? 1 : -1;
                        });
                    this.setState({
                        items: sorted,
                    });
                } else {
                    this.showErrorMessage(responseJson.description);
                }
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this.fetchData();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }


    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner />;
        }

        let nextView = "ServiceView";

        const elements = this.state.items.map((item, key) => {
            return (
                <ListItem key={key} isActive={true} onClick={() => {
                    const props = {
                        tag: item.code,
                    };

                    this.props.gotoNextView({
                        breadcrumbName: item.name.toLowerCase(),
                        nextView: nextView,
                        props: props
                    });
                }}>
                    <ServiceTag name={item.name} />
                </ListItem>
            );
        });

        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--doctor">
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/tags.js
 **/